import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { translate } from '@web-platform/shared-universal-translations';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';

type SponsoredCallToActionParams = {
  pioPartnerName?: string;
  pioAgencyName?: string;
};

export const getSponsoredCallToActionData = ({
  pioAgencyName,
  pioPartnerName,
}: SponsoredCallToActionParams = {}) => {
  const dsaModalEnabled = getFeatureDecision(
    FEATURE_DECISION_KEYS.ADS_DSA_MODAL_UPDATED_WITH_LEGAL_NAME_WEB,
  );

  let whySeeingDescription: string;
  if (!dsaModalEnabled || !pioPartnerName) {
    whySeeingDescription = translate('ktxt_Ad_info_message');
  } else if (pioAgencyName && pioAgencyName !== pioPartnerName) {
    whySeeingDescription = translate('ktxt_dsa_why_seeing_body_with_agency', {
      partner: pioPartnerName,
      agency: pioAgencyName,
    });
  } else {
    whySeeingDescription = translate('ktxt_dsa_why_seeing_body_single', {
      partner: pioPartnerName,
    });
  }

  return {
    text: translate('ktxt_promotion_sponsored'),
    bottomSheetContent: [
      {
        title: '',
        description: whySeeingDescription,
      },
      {
        title: translate('ktxt_dsa_based_on_now_title'),
        description: translate('ktxt_dsa_based_on_now_body'),
      },
      {
        title: translate('ktxt_dsa_based_on_past_title'),
        description: translate('ktxt_dsa_based_on_past_body'),
      },
    ],
    bottomSheetTitle: translate('ktxt_ad_info_title'),
  };
};
